import {  COLUMN_ACTION_TYPE, COLUMN_COMPANY, COLUMN_DATE_TIME, COLUMN_DEPARTMENT, COLUMN_DETAILS, COLUMN_DISPLAY_NAME, COLUMN_ENABLED, COLUMN_FIELD, COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_OPERATOR, COLUMN_SECOND_NAME, COLUMN_SITE, COLUMN_SUFFIX, COLUMN_TITLE, COLUMN_TYPE, COLUMN_UNIQUE_IDENTIFIER } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const EnrolmentAuditColumns: TableColumn[] = [
    {
        heading: "Date/Time",
        accessor: "dateTime",
        isNumeric: false,
        id: 0,
        sortByName: "dateTimeLocal",
        sortDirection: "asc",
        active: true,
        translationKey: "dateTime",
        columnId: COLUMN_DATE_TIME,
    },
    {
        heading: "Operator",
        accessor: "operator",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "operator",
        columnId: COLUMN_OPERATOR
    },
    {
        heading: "Action",
        accessor: "action",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "action",
        columnId: COLUMN_ACTION_TYPE
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE
    },
    {
        heading: "Field",
        accessor: "field",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "field",
        columnId: COLUMN_FIELD
    },
    {
        heading: "Before",
        accessor: "valueOld",
        isNumeric: false,
        id: 5,
        active: true,
        translationKey: "before",
        columnId: COLUMN_DETAILS
    },
    {
        heading: "After",
        accessor: "valueNew",
        isNumeric: false,
        id: 6,
        active: true,
        translationKey: "after",
        columnId: COLUMN_DETAILS
    }
]

export default EnrolmentAuditColumns;